import React from 'react';
export const Footer = () => {
  return <footer className="bg-ink py-12 px-[5vw]" data-id="element-183">
      <div className="max-w-6xl mx-auto flex flex-col items-center" data-id="element-184">
        <div className="flex flex-wrap justify-center gap-6 md:gap-10 mb-10" data-id="element-185">
          <a href="#" className="text-white/70 hover:text-gold transition-colors text-sm font-medium" data-id="element-186">
            Termos de uso
          </a>
          <a href="#" className="text-white/70 hover:text-gold transition-colors text-sm font-medium" data-id="element-187">
            Política de privacidade
          </a>
          <a href="#" className="text-white/70 hover:text-gold transition-colors text-sm font-medium" data-id="element-188">
            Suporte no WhatsApp
          </a>
          <a href="#" className="text-white/70 hover:text-gold transition-colors text-sm font-medium" data-id="element-189">
            Login
          </a>
        </div>

        <div className="text-center" data-id="element-190">
          <p className="text-white/50 text-sm mb-2" data-id="element-191">
            © 2026 Aurora Precificador
          </p>
          <p className="text-white/50 text-sm flex items-center justify-center gap-1.5" data-id="element-192">
            Feito com <span data-id="element-193">🌸</span> para artesãs brasileiras
          </p>
        </div>
      </div>
    </footer>;
};